import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import animateScrollTo from 'animated-scroll-to';
import { MediaRichTextEditor } from '@nextiva/rich-text-editor';

import { setHeaderTextContent } from '../../../actions/headerEditorActions';

import { large } from '../../../domains/richText/config/DefaultFontSize';
import ImageToolbar from '../../../domains/richText/components/ImageToolbar';
import HeaderTextEditorToolbar from '../HeaderTextEditorToolbar';

import styles from './HeaderTextEditor.scss';

class HeaderTextEditor extends Component {
  static propTypes = {
    id: PropTypes.string,
    content: PropTypes.object,
    className: PropTypes.string,
    setHeaderLogoTextContent: PropTypes.func.isRequired,
    style: PropTypes.object,
  };

  static defaultProps = {
    content: null,
    className: '',
    id: 'headerTextEditor',
    style: {},
  };

  state = {
    hovered: false,
    focused: false,
  };

  static imageToolbar = {
    Content: ImageToolbar,
    outHeight: 20,
    width: 110,
  };

  handleMouseEnter = () => {
    this.setState({ hovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ hovered: false });
  };

  isSelected() {
    const { focused, hovered } = this.state;
    return focused || hovered;
  }

  handleFocus = () => {
    this.setState({ focused: true });
  };

  handleBlur = () => {
    this.setState({ focused: false });
    animateScrollTo(0, {
      element: this.el,
    });
  };

  render() {
    const {
      className,
      setHeaderLogoTextContent,
      content,
      id,
      style,
    } = this.props;

    return (
      <div className={cx(styles.container, className)}>
        <div
          className={styles.textContainer}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          style={style}
        >
          <div
            ref={el => {
              this.el = el;
            }}
            className={cx(styles.text, {
              [styles.selected]: this.isSelected(),
            })}
          >
            <MediaRichTextEditor
              spellCheck
              id={id}
              value={content}
              onChange={setHeaderLogoTextContent}
              defaultFontSize={large}
              placeholder={'Start typing here..'}
              imageToolbar={HeaderTextEditor.imageToolbar}
            />
          </div>
          {this.isSelected() && <HeaderTextEditorToolbar id={id} />}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  setHeaderLogoTextContent: setHeaderTextContent,
};

export default connect(
  null,
  mapDispatchToProps,
)(HeaderTextEditor);
